/**
 * Format episode series for display.
 * Handles both legacy string format and new array format.
 *
 * @param {string|string[]|null|undefined} series - Episode series value
 * @returns {string} - Comma-separated series names, or 'No Series' fallback
 */
export const formatSeries = (series) => {
  if (!series) return 'No Series';
  if (Array.isArray(series)) {
    return series.length > 0 ? series.join(', ') : 'No Series';
  }
  return series;
};
